import { finishGamePlayer } from "@/api/playerGame"
import Typography from "@/components/shared/Typography"
import React, { useEffect, useRef, useState } from "react"

const scrollIcon = (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.4722 9.32422L21.4722 34.1113"
      stroke="white"
      stroke-width="3.56755"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.4976 35.5697C25.5121 37.9867 23.9379 40.979 22.3592 42.406C22.1171 42.6283 21.8005 42.7516 21.4718 42.7516C21.1432 42.7516 20.8265 42.6283 20.5844 42.406C19.0046 40.979 17.4304 37.9856 16.4449 35.5697C16.1573 34.8617 16.6902 34.1125 17.455 34.1125L25.4875 34.1125C26.2523 34.1125 26.7863 34.8617 26.4976 35.5697Z"
      fill="white"
    />
    <path
      d="M16.4443 8.1818C17.4298 5.76478 19.004 2.7725 20.5827 1.34548C20.8247 1.12321 21.1414 0.999884 21.4701 0.999884C21.7987 0.999884 22.1154 1.12321 22.3575 1.34548C23.9373 2.7725 25.5114 5.7659 26.497 8.1818C26.7846 8.88973 26.2517 9.63892 25.4869 9.63892L17.4544 9.63892C16.6896 9.63892 16.1555 8.88973 16.4443 8.1818Z"
      fill="white"
    />
  </svg>
)
interface GameContentProps {
  gameSrc: string
  gameId?: string
}

const GameContent: React.FC<GameContentProps> = ({ gameSrc, gameId }) => {
  const containerRef = useRef(null)
  const [showHint, setShowHint] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setShowHint(false)
    }, 5000)
  }, [])

  return (
    <div ref={containerRef} style={{ position: "relative", height: "100%" }}>
      <iframe
        className="no-scrollbar min-w-[340px]"
        title="External Content"
        src={gameSrc}
        width="100%"
        height="100%"
        loading="lazy"
      />
      {showHint && (
        <div className="absolute left-1/2 top-1/2 flex w-[80%] -translate-x-1/2 -translate-y-1/2 transform flex-col items-center gap-10 ">
          {scrollIcon}
          <Typography type="l" className="text-center">
            Posouvej se v komiksu. Abys mohl pokračovat dál, musíš zodpovědět správně na otázku.
          </Typography>
        </div>
      )}
    </div>
  )
}

export default GameContent
